<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="优惠券标题">
                <a-input v-model="queryParam.couponName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="优惠券类型">
                <a-select v-model="queryParam.couponType" placeholder="请选择">
                  <a-select-option :key="10">代金券</a-select-option>
                  <a-select-option :key="20">折扣券</a-select-option>
                  <a-select-option :key="30">免单券</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="24">
              <a-form-item label="过期状态">
                <a-select v-model="queryParam.overdueStatus" placeholder="请选择">
                  <a-select-option :key="1">未过期</a-select-option>
                  <a-select-option :key="0">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="投放状态">
                <a-select v-model="queryParam.putonStatus" placeholder="请选择">
                  <a-select-option :key="0">取消投放</a-select-option>
                  <a-select-option :key="10">等待投放</a-select-option>
                  <a-select-option :key="20">投放中</a-select-option>
                  <a-select-option :key="30">违规下架</a-select-option>
                  <a-select-option :key="40">等待审核</a-select-option>
                  <a-select-option :key="50">审核不通过</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a-button
type="primary"
@click="handleChoose"
style="margin-left: 8px"
                  :disabled="ids.length ? false : true">确认选择</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- 增加修改 -->
      <CreateForm
ref="createForm"
:userList="userList"
:statusOptions="dict.type['sys_enable_disable']"
        @ok="getList" />
      <!-- 批量导入 -->
      <!-- 数据展示 -->
      <a-table
:loading="loading"
:size="tableSize"
rowKey="id"
:columns="columns"
:data-source="list"
        :row-selection="{ type: 'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
:bordered="tableBordered">
        <span slot="applyForVal" slot-scope="text, record">
          <a-tooltip>
            <template #title>
              <div v-html="record.applyForVal"></div>
            </template>
            <a> 查看 </a>
          </a-tooltip>
        </span>
        <span slot="reviewerEply" slot-scope="text, record">
          <a-tooltip>
            <template #title>
              <div v-html="record.reviewerEply"></div>
            </template>
            <a> 查看 </a>
          </a-tooltip>
        </span>

        <span slot="reviewerStatus" slot-scope="text, record">
          {{ record.reviewerStatus == 0 ? '待审核' : record.reviewerStatus == 1 ? '通过' : '失败' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:coupon:edit']"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['coupon:coupon:query', 'coupon:coupon:edit']" />

          <a-dropdown v-hasPermi="['coupon:coupon:query', 'coupon:coupon:edit']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['coupon:coupon:query']">
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['coupon:coupon:send']">
                <a @click="handleDistribute(record)">发放优惠券</a>
              </a-menu-item>

              <a-menu-item v-hasPermi="['coupon:userecord:list']">
                <a @click="looking(record)">查看使用记录</a>
              </a-menu-item>

              <a-menu-item v-hasPermi="['coupon:coupon:tj']">
                <a @click="infoALL(record)">信息统计</a>
              </a-menu-item>

              <a-menu-item v-hasPermi="['coupon:user:list']">
                <a @click="handleUserList(record)">查询用户关联</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['coupon:coupon:check']" v-if="record.putonStatus === 40">
                <a @click="handleAudit(record)">审核</a>
              </a-menu-item>

              <a-menu-item v-if="[10, 0, 30].includes(record.putonStatus)" v-hasPermi="['coupon:coupon:put']">
                <a @click="handleLaunch(record)">投放</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['coupon:coupon:cancelPut']" v-if="record.putonStatus !== 0">
                <a @click="handleCancelLaunch(record)">取消投放</a>
              </a-menu-item>

              <a-menu-item v-hasPermi="['coupon:coupon:illegal']">
                <a @click="handleViolate(record)">违规下架</a>
              </a-menu-item>

              <a-menu-item v-hasPermi="['coupon:activation:list']">
                <a @click="handleCode(record)">查询优惠券激活码</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['coupon:coupon:remove']">
                <a v-hasPermi="['coupon:coupon:remove']" @click="handleDelete(record)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
class="ant-table-pagination"
show-size-changer
show-quick-jumper
:current="queryParam.pageNum"
        :total="total"
:page-size="queryParam.pageSize"
:showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
@change="changeSize" />
    </a-card>

    <a-modal title="优惠券审核" :visible="auditModalVisible" @ok="handleAuditSubmit" @cancel="auditModalVisible = false">
      <a-form-model
ref="auditForm"
:model="auditForm"
:rules="auditRules"
:label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }">
        <a-form-model-item label="审核结果" prop="auditStatus">
          <a-select v-model="auditForm.auditStatus" placeholder="请选择审核结果">
            <a-select-option :value="10">通过</a-select-option>
            <a-select-option :value="50">不通过</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="审核说明" prop="auditingVal" v-if="auditForm.auditStatus === 50">
          <a-textarea
v-model="auditForm.auditingVal"
placeholder="请输入审核不通过原因"
:rows="3"
:max-length="200"
            show-word-limit />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import {
  couponlist,
  deletecouponlist,
  cancelCouponLaunch,
  auditCoupon,
  updatePutonStatus,
  updatePutonStatusput,
} from '@/api/coupon/controller/index.js'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'Post',

  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    couponId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      auditModalVisible: false,
      auditForm: {
        id: null,
        auditStatus: null,
        auditingVal: '',
      },
      auditRules: {
        auditStatus: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        auditingVal: [
          { required: true, message: '请输入审核不通过原因', trigger: 'blur' },
          { min: 5, max: 200, message: '长度在 5 到 200 个字符', trigger: 'blur' },
        ],
      },
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        couponName: undefined,
        mobile: undefined,
        couponType: undefined,
        putonStatus: undefined,
        overdueStatus: 1,
        showType: 1,
        putonStatus: 20,
      },
      columns: [
        {
          title: '优惠券标题',
          dataIndex: 'couponName',
          align: 'center',
          ellipsis: true,
        },
        {
          title: '优惠券类型',
          dataIndex: 'couponType',
          align: 'center',
          customRender: (text) => {
            const map = { 10: '代金券', 20: '折扣券', 30: '免单券' }
            return map[text] || text
          },
        },
        // columns 里把原来的两列删掉，换成下面这一列
        {
          title: '优惠内容',
          dataIndex: 'reduceAmount', // 随意写个存在的字段即可
          align: 'center',
          customRender: (text, record) => {
            const { couponType, reduceAmount, couponDiscount } = record
            if (couponType === 10) {
              // 代金券
              return `减 ${reduceAmount} 元`
            }
            if (couponType === 20) {
              // 折扣券
              return `${(couponDiscount * 10).toFixed(1)} 折`
            }
            if (couponType === 30) {
              // 免单券
              return '免单'
            }
            return '-' // 兜底
          },
        },
        {
          title: '使用门槛',
          dataIndex: 'cashCondition',
          align: 'center',
          customRender: (text) => `满¥${text}可用`,
        },
        {
          title: '有效期',
          align: 'center',
          customRender: (text, record) => {
            if (record.validTimeType === 1) {
              return `${record.startTime} ~ ${record.endTime}`
            } else {
              return `领取后 ${record.validDays} 天内有效`
            }
          },
        },
        // {
        //   title: '领取时间',
        //   dataIndex: 'receiveTime',
        //   align: 'center',
        //   customRender: (text) => (text ? this.parseTime(text) : '-')
        // },
        // {
        //   title: '使用时间',
        //   dataIndex: 'useTime',
        //   align: 'center',
        //   customRender: (text) => (text ? this.parseTime(text) : '-')
        // },
        // {
        //   title: '过期状态',
        //   dataIndex: 'overdueStatus',
        //   align: 'center',
        //   customRender: (text) => {
        //     return text === 1 ? '未过期' : '已过期'
        //   }
        // },
        // {
        //   title: '投放状态',
        //   dataIndex: 'putonStatus',
        //   align: 'center',
        //   customRender: (text) => {
        //     const map = {
        //       0: '取消投放',
        //       10: '等待投放',
        //       20: '投放中',
        //       30: '违规下架',
        //       40: '等待审核',
        //       50: '审核不通过'
        //     }
        //     return map[text] || text
        //   }
        // },
        {
          title: '库存',
          dataIndex: 'stocks',
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    looking(record) {
      this.$refs.statDrawer.open(record)
    },
    infoALL(record) {
      this.$refs.infoDrawer.open(record)
    },
    handleUserList(record) {
      this.$refs.userDrawer.open(record.id)
    },
    handleCode(record) {
      this.$refs.codeDrawer.open(record.id)
    },
    handleDetail(record) {
      this.$refs.detailDrawer.open(record)
    },

    handleDistribute(record) {
      this.$refs.distributeDrawer.open(record.id)
    },
    handleLaunch(row) {
      const that = this
      this.$confirm({
        title: '确认投放？',
        content: '投放后优惠券将立即对用户可见。',
        onOk() {
          updatePutonStatusput({ id: row.id })
            .then(() => {
              that.$message.success('投放成功')
              that.getList()
            })
            .catch(() => {
              that.$message.error('投放失败')
            })
        },
      })
    },
    handleViolate(row) {
      const that = this
      this.$confirm({
        title: '确认违规下架？',
        content: '下架后优惠券将停止投放，已领取用户仍可使用。',
        onOk() {
          // 直接调接口把状态改为 30

          updatePutonStatus({ id: row.id })
            .then(() => {
              that.$message.success('违规下架成功')
              that.getList()
            })
            .catch(() => {
              that.$message.error('违规下架失败')
            })
        },
      })
    },
    // 打开审核弹框
    handleAudit(record) {
      this.auditForm = {
        id: record.id,
        auditStatus: null,
        auditingVal: '',
      }
      this.auditModalVisible = true
    },
    // 点击选择
    handleChoose() {
      console.log(this.selectedRows, 'selectedRowsselectedRows')
      this.$emit('changeYou', this.selectedRows[0])
    },
    handleAuditSubmit() {
      this.$refs.auditForm.validate((valid) => {
        if (!valid) return // 校验未通过直接拦截

        const params = {
          id: this.auditForm.id,
          auditStatus: this.auditForm.auditStatus,
          auditingVal: this.auditForm.auditingVal,
        }

        auditCoupon(params)
          .then(() => {
            this.$message.success('审核提交成功')
            this.auditModalVisible = false
            this.getList()
          })
          .catch(() => {
            this.$message.error('审核提交失败')
          })
      })
    },
    handleCancelLaunch(record) {
      const that = this
      this.$confirm({
        title: '确认取消投放？',
        content: '取消后该优惠券将不再对用户展示，但已领取的用户仍可使用。',
        onOk() {
          return cancelCouponLaunch({ id: record.id })
            .then(() => {
              that.$message.success('取消投放成功')
              that.getList()
            })
            .catch(() => {
              that.$message.error('取消投放失败')
            })
        },
      })
    },
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      couponlist(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
        if (this.couponId) { // 先判断是否传入了packageId
          // 遍历表格数据，找到id与packageId匹配的行
          const matchedRow = this.list.find(item => item.id === this.packageId)
          if (matchedRow) { // 找到匹配行时，设置选中状态
            this.selectedRowKeys = [matchedRow.id] // 单选只需传入一个id数组
            this.ids = [matchedRow.id] // 同步更新ids，确保后续操作（如确认选择）能拿到选中id
            this.selectedRows = [matchedRow]
          }
        }
      })
    },
    // 点击确定
    onChange(e) { },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        couponName: undefined,
        mobile: undefined,
        couponType: undefined,
        overdueStatus: 1,
        showType: 1,
        putonStatus: 20,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return deletecouponlist(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'coupon/coupon/export',
            {
              ...that.queryParam,
            },
            `优惠券列表信息${new Date().getTime()}.xlsx`,
            'GET'
          )
        },
        onCancel() { },
      })
    },
  },
}
</script>
